import React from 'react'
import PropTypes from 'prop-types'
import { getDocumentFromPageModel } from '../utilities/utilities.js'
import { getLocalPath } from '../../utility'
import DOMPurify from 'dompurify'

const FundCardIntro = (sectionIntro, page) => {
  const { illustration, headline, body, cta } = sectionIntro
  const text = cta?.text
  const target = cta?.target
  const link = cta?.link && cta?.link[0]
  const href = link?.string
  const pageRef = illustration?.image?.$ref
  const { original, displayName, id } = getDocumentFromPageModel(page, pageRef)

  return (
    <div
      data-analytics="fund-card-section-intro"
      className="u-flex u-flexCol u-flexAlignItemsStart u-flexAuto u-sizeFull"
    >
      <a
        href={DOMPurify.sanitize(href)}
        className=""
        target="_self"
        rel="noreferrer"
      >
        {original && (
          <img
            className="u-sizeFull"
            src={`${original.links.site.href}`}
            alt={displayName}
            id={id}
          />
        )}
      </a>
      <div className="u-sizeFull u-marginTop2gu ">
        <h2
          data-analytics="fund-card-section-intro-title"
          className="u-paddingBottom1gu"
        >
          <a
            href={DOMPurify.sanitize(href)}
            className="Link  u-textSecondary u-textColorBrand u-textUppercase"
            target={target}
            rel="noreferrer"
          >
            {headline}
          </a>
        </h2>
        <p className="Content">{body}</p>
        {href && text && (
          <>
            {cta?.asButton ? (
              <a
                href={DOMPurify.sanitize(href)}
                className="Button Button--secondary u-marginTop5gu"
                target={target}
                rel="noreferrer"
                data-analytics="fund-card-section-intro-button"
              >
                {text}
              </a>
            ) : (
              <a
                href={DOMPurify.sanitize(href)}
                className="Link u-textColorBrandLight u-textSecondary u-textKernLoose u-posRelative hover-underline-animation u-marginTop5gu"
                target={target}
                rel="noreferrer"
                data-analytics="fund-card-section-intro-link"
              >
                {text}
                <img
                  className="u-alignMiddle"
                  alt=""
                  src={DOMPurify.sanitize(
                    `${getLocalPath()}/webfiles/latest/assets/cti/images/icon_chevron_brand_light.svg`
                  )}
                />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}

FundCardIntro.propTypes = {
  sectionIntro: PropTypes.object,
  page: PropTypes.object,
}
export default FundCardIntro
